import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseBrand() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
      graid: isEmpty(state.graid),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName || errorState.graid) {
      enqueueSnackbar("لطفا اطلاعات برند را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getBrandList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Brands?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getBrandListGift = (search, callback, bool) => {
    MyAxios.get(`Admin_Brands?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchColumn: "",
            forceRefresh: true,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllBrandList = (callback) => {
    MyAxios.get(`Admin_Brands?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getBrandByID = (id, callback) => {
    MyAxios.get(`Admin_Brands/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateBrand = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Brands`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("برند با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addBrand = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Brands`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("برند با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteBrand = (id, callback) => {
    const data = new FormData();
    data.append("BrandID", id);
    MyAxios.delete(`Admin_Brands`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("برند با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getBrandList,
    getAllBrandList,
    getBrandByID,
    validate,
    updateBrand,
    addBrand,
    deleteBrand,
    getBrandListGift,
  };
}
